import { FormGroup } from "@angular/forms";
import { FormlyView } from "../FormlyView";
import { FieldDefinition } from "../../../../sections/medicinalProduct/message/fieldDefinition";
import { Injector } from "@angular/core";

export class ProductPreviousEvCodeEntity extends FormlyView {

    constructor(injector: Injector, model: any) {
        const fieldDefinition: FieldDefinition = new FieldDefinition(injector);
        super( new FormGroup({}), 
            [...fieldDefinition.productPreviousEvCodeFields], model);
        // model                
    }

}